module.exports = __webpack_public_path__ + "assets/5d41516027801260e584dc01d37cf876.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_5.mp3
 ** module id = 42
 ** module chunks = 0
 **/